import { Badge, HStack, Progress, Text } from '@chakra-ui/react'

import { Milliseconds } from '@/utils/milliseconds'

type Props = {
  createdAt: Date
  status: string
}

export default function Component({ status, createdAt }: Props) {
  const isFinished =
    ['DONE', 'CLOSED', 'CANCELED'].find((ea) => ea === status) !== undefined
  if (isFinished) return null

  const expireTime = new Date(createdAt).getTime() + Milliseconds({ hours: 72 })
  const remainingTime = Math.floor(
    (expireTime - new Date().getTime()) / Milliseconds({ hours: 1 }),
  )
  const color =
    remainingTime > 24 ? 'primary' : remainingTime > 12 ? 'yellow' : 'red'

  return remainingTime > 0 ? (
    <HStack>
      <Text>{remainingTime}h</Text>
      <Progress
        value={remainingTime}
        max={72}
        flex={1}
        hasStripe
        bg="blackAlpha.100"
        colorScheme={color}
        borderRadius="sm"
        size="sm"
      />
    </HStack>
  ) : (
    <Badge colorScheme="red" variant="solid">
      Expirado
    </Badge>
  )
}
